import { Link } from "react-router-dom";
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Divider,
  IconButton,
  Stack,
} from "@mui/material";
import {
  Instagram,
  Facebook,
  Twitter,
  YouTube,
  LinkedIn,
  Email,
} from "@mui/icons-material";
import Logo from "../images/logo.png";

const Footer = () => {
  const handleSubscribe = (e) => {
    e.preventDefault();
    // Handle newsletter subscription
  };

  const footerLinks = {
    shop: [
      { name: "Women", path: "/products?category=women" },
      { name: "Men", path: "/products?category=men" },
      { name: "Accessories", path: "/products?category=accessories" },
      { name: "New Arrivals", path: "/products?category=new-arrivals" },
      { name: "Sale", path: "/products?category=sale" },
    ],
    corporate: [
      { name: "About JK Tech", path: "/about" },
      { name: "Careers", path: "/careers" },
      { name: "Sustainability", path: "/sustainability" },
      { name: "Press", path: "/press" },
      { name: "Investor Relations", path: "/investor-relations" },
    ],
    help: [
      { name: "Customer Service", path: "/customer-service" },
      { name: "My Account", path: "/account" },
      { name: "Find a Store", path: "/stores" },
      { name: "Legal & Privacy", path: "/legal" },
      { name: "Contact", path: "/contact" },
    ],
  };

  const socialLinks = [
    { icon: Instagram, label: "Instagram", href: "#" },
    { icon: Facebook, label: "Facebook", href: "#" },
    { icon: Twitter, label: "Twitter", href: "#" },
    { icon: YouTube, label: "YouTube", href: "#" },
    { icon: LinkedIn, label: "LinkedIn", href: "#" },
  ];

  return (
    <Box component="footer" sx={{ bgcolor: "background.paper", mt: 8 }}>

      {/* Footer Links Section */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Grid container spacing={4}>
          {/* Shop Column */}
          <Grid item xs={6} sm={3}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: "text.primary",
                mb: 2,
                fontSize: "1rem",
              }}
            >
              Shop
            </Typography>
            <Stack spacing={1}>
              {footerLinks.shop.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      color: "text.secondary",
                      "&:hover": {
                        color: "primary.main",
                      },
                    }}
                  >
                    {link.name}
                  </Typography>
                </Link>
              ))}
            </Stack>
          </Grid>

          {/* Corporate Info Column */}
          <Grid item xs={6} sm={3}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: "text.primary",
                mb: 2,
                fontSize: "1rem",
              }}
            >
              Corporate Info
            </Typography>
            <Stack spacing={1}>
              {footerLinks.corporate.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      color: "text.secondary",
                      "&:hover": {
                        color: "primary.main",
                      },
                    }}
                  >
                    {link.name}
                  </Typography>
                </Link>
              ))}
            </Stack>
          </Grid>

          {/* Help Column */}
          <Grid item xs={6} sm={3}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: "text.primary",
                mb: 2,
                fontSize: "1rem",
              }}
            >
              Help
            </Typography>
            <Stack spacing={1}>
              {footerLinks.help.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      color: "text.secondary",
                      "&:hover": {
                        color: "primary.main",
                      },
                    }}
                  >
                    {link.name}
                  </Typography>
                </Link>
              ))}
            </Stack>
          </Grid>

          {/* Newsletter Column */}
          <Grid item xs={6} sm={3}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: "text.primary",
                mb: 2,
                fontSize: "1rem",
              }}
            >
              Newsletter
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
                mb: 2,
              }}
            >
              Sign up for exclusive offers and updates
            </Typography>
            <Button
              variant="outlined"
              startIcon={<Email />}
              onClick={handleSubscribe}
              sx={{
                borderColor: "text.primary",
                color: "text.primary",
                textTransform: "none",
                borderRadius: "4px",
                px: 2,
                "&:hover": {
                  borderColor: "primary.main",
                  bgcolor: "primary.light",
                  color: "primary.main",
                },
              }}
            >
              Subscribe
            </Button>
          </Grid>
        </Grid>
      </Container>

      <Divider />

      {/* Bottom Section */}
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            gap: 3,
            mb: 3,
          }}
        >
          {/* Logo */}
          <Link to="/" style={{ textDecoration: "none" }}>
            <Box
              component="img"
              src={Logo}
              alt="JKTech"
              sx={{
                height: 40,
                width: "auto",
              }}
            />
          </Link>

          {/* Region Selector */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              USD $.
            </Typography>
          </Box>
        </Box>

        {/* Social Media Icons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            mb: 3,
          }}
        >
          {socialLinks.map((social) => {
            const IconComponent = social.icon;
            return (
              <IconButton
                key={social.label}
                href={social.href}
                aria-label={social.label}
                sx={{
                  color: "text.secondary",
                  "&:hover": {
                    color: "primary.main",
                  },
                }}
              >
                <IconComponent />
              </IconButton>
            );
          })}
        </Box>

          {/* Copyright */}
        <Typography
          variant="body2"
          sx={{
            textAlign: "center",
            color: "text.secondary",
          }}
        >
          © 2026 JK Tech. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
